import React from 'react';
import './GlobalLoader.css';

// Global loading state management
let globalLoadingState = {
    isLoading: false,
    loadingCount: 0,
    listeners: new Set()
};

const updateLoadingState = (newState) => {
    globalLoadingState = { ...globalLoadingState, ...newState };
    globalLoadingState.listeners.forEach(listener => listener(globalLoadingState.isLoading));
};

export const startGlobalLoading = () => {
    globalLoadingState.loadingCount += 1;
    updateLoadingState({ isLoading: true });
};

export const stopGlobalLoading = () => {
    globalLoadingState.loadingCount = Math.max(0, globalLoadingState.loadingCount - 1);
    updateLoadingState({ isLoading: globalLoadingState.loadingCount > 0 });
};

export default function GlobalLoader() {
    const [isLoading, setIsLoading] = React.useState(globalLoadingState.isLoading);

    React.useEffect(() => {
        const listener = (loadingState) => setIsLoading(loadingState);
        globalLoadingState.listeners.add(listener);
        return () => globalLoadingState.listeners.delete(listener);
    }, []);

    if (!isLoading) {
        return null;
    }

    return (
        <div className="global-loader-overlay">
            <div className="global-loader-content">
                <div className="global-spinner">
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                    <div className="spinner-ring"></div>
                </div>
                <p className="global-loader-text">Cargando...</p>
            </div>
        </div>
    );
}
